export default __webpack_public_path__ + "static/media/activity-box-img.0c9bffaa.png";